import React from 'react';
import { IconButton } from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';

const StyledDialogTitle = styled(MuiDialogTitle)(() => ({
  margin: 0,
  padding: 16,
  backgroundColor: '#5eb676'
}));

const CloseButton = styled(IconButton)(() => ({
  color: '#000000de',
  padding: 0
}));

const TitleTypography = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

const CustomDialogTitle = props => {
  const { children, onClose, ...other } = props;
  return (
    <StyledDialogTitle {...other}>
      <TitleTypography variant="h6">
        {children}
        <CloseButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      </TitleTypography>
    </StyledDialogTitle>
  );
};

export default CustomDialogTitle;
